import Env from '../base/env';
import Component from 'gia/Component';
import gsap from 'gsap'
import SplitText  from "../vendor/gsap-bonus-umd/SplitText";
gsap.registerPlugin(SplitText);

export default class Module extends Component
{
  mount() {
    this.DOM = {}
    this.DOM.view = this.element
    if(Env.desktop)  {
      this.events()
    }

  }

  events()
  {
    //? Btn Contact
    const $out = this.DOM.view.querySelector('.out')
    const $in = this.DOM.view.querySelector('.in')

    const splitTriggerOut = new SplitText($out,{charsClass:'char'})
    const splitTriggerIn = new SplitText($in,{charsClass:'char'})
    gsap.set(splitTriggerIn.chars , { y : 30 })
    this.DOM.view.addEventListener('mouseenter',()=>{
      gsap.fromTo(splitTriggerOut.chars , { y : 0 } , { duration:.4, y: -30, ease:'power3.inOut', stagger:.02})
      gsap.fromTo(splitTriggerIn.chars , { y : 30 } , { immediateRender:true, duration:.4, y: 0, ease:'power3.inOut', stagger:.02})
    })

    this.DOM.view.addEventListener('mouseleave',()=>{
      gsap.to(splitTriggerOut.chars , { duration:.4, y: 0, ease:'power3.inOut', stagger:.02})
      gsap.to(splitTriggerIn.chars , { duration:.4, y: 30, ease:'power3.inOut', stagger:.02})
    })
  }

  unmount()
  {

  }
}
